<template>
 <div class="review_page">
  <testmonialArea></testmonialArea>
  <reviewArea></reviewArea>
 </div>
</template>

<script>
import testmonialArea from '@/components/home/testmonialArea.vue';
import reviewArea from '@/components/testimonial/reviewArea.vue';

export default {
   name:'Testimonial',
   data(){
    return{
    }
   },
   components:{
      
       testmonialArea,
       reviewArea
   },
   methods:{},
    mounted(){
         document.body.classList.add('ReviewPage');
    },
    destroyed(){
      document.body.classList.remove('ReviewPage');
    }
}
</script>
<style lang="scss">
.ReviewPage{
.review_page{
   margin-top: -80px; 
}
.testimnoal_section .text_testi .more{
display: none;
}    
}

</style>